import { useRouter } from "next/router";
import { Link, Box } from "@chakra-ui/react";
import { GetCookie } from "../provider/common";
import axios from "axios";
import { useCallback } from "react";
import styles from "../styles/components/searchFigma/ResultListItemMobile.module.css";

const Goto = ({ pics, data, isLoginCheck, keyword }) => {
  const router = useRouter();

  const CombineBotAsked = useCallback(async () => {
    if (isLoginCheck === "1") {
      try {
        const body = [
          {
            it_id: data.it_id,
            it_brand: data.manufacturer,
            it_name: data.pn,
            it_maker: data.source,
            // 재고를 다 넘기는게 아니라 무조건 1개만 추가
            qty: 1,
          },
        ];

        const result = await axios.post(
          `${process.env.PANDA_API_URL}/api/mall/insertQuoteLists`,
          body,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${await GetCookie("token")}`,
            },
          },
        );

        if (result.data.status === 200) {
          if (
            window.confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?",
            )
          ) {
            router.push(`/marketplace/cart`);
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (error) {
        console.error("⛔ CombineBotAsked Error:", error);
        alert("견적바구니에 저장이 실패하였습니다.");
      }
    } else {
      const href = `/auth/login?before=/search/lists?keyword=${encodeURIComponent(
        keyword,
      )}`;
      router.push(href);
    }
  }, [isLoginCheck, data, pics, keyword, router]);

  // 견적바로받기 버튼
  const renderInquiryButton = () => (
    <div onClick={CombineBotAsked} className={styles.purchaseTag}>
      <div className={styles.iconLightning}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.3656 7.84124L6.36559 15.3412C6.29141 15.4204 6.19349 15.4733 6.08661 15.4919C5.97974 15.5106 5.8697 15.4939 5.7731 15.4445C5.67651 15.3952 5.5986 15.3157 5.55113 15.2181C5.50366 15.1206 5.48921 15.0102 5.50996 14.9037L6.42621 10.3206L2.82434 8.96812C2.74698 8.93918 2.678 8.89154 2.62355 8.82944C2.5691 8.76733 2.53089 8.69271 2.51232 8.61224C2.49374 8.53176 2.4954 8.44794 2.51713 8.36826C2.53886 8.28858 2.57998 8.21553 2.63684 8.15562L9.63684 0.655618C9.71102 0.576453 9.80893 0.523563 9.91581 0.504929C10.0227 0.486295 10.1327 0.502928 10.2293 0.552319C10.3259 0.60171 10.4038 0.681178 10.4513 0.778732C10.4988 0.876285 10.5132 0.986631 10.4925 1.09312L9.57371 5.68124L13.1756 7.03187C13.2524 7.061 13.3208 7.10859 13.3748 7.17045C13.4288 7.2323 13.4668 7.30651 13.4853 7.38652C13.5039 7.46652 13.5024 7.54986 13.4811 7.62917C13.4598 7.70848 13.4192 7.78132 13.3631 7.84124H13.3656Z"
            fill="#7D8593"
          />
        </svg>
      </div>
      <div className={styles.buttonText}>
        <div className={styles.buttonTextCpation1}>견적받기</div>
      </div>
      <div className={styles.iconChevronRight}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
            fill="#7D8593"
          />
        </svg>
      </div>
    </div>
  );
  // 구매하기 버튼
  const renderBuyButton = (href) => (
    <a href={href}>
      <div className={styles.purchaseTag}>
        <div className={styles.iconLightning}></div>
        <div className={styles.buttonText}>
          <div className={styles.buttonTextCpation1}>구매하기</div>
        </div>
        <div className={styles.iconChevronRight}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
              fill="#7D8593"
            />
          </svg>
        </div>
      </div>
    </a>
  );

  // arrow 에 L7805CDT-TR 에 MOQ 가 1인 경우 예외 처리
  if (
    pics.source === "arrow" &&
    data.pn === "L7805CDT-TR" &&
    Number(pics.moq) === 1
  ) {
    return renderInquiryButton();
  }

  if (pics.source === "partner") return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.item_price) === 0)
    return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.price) === 0)
    return renderInquiryButton();

  // 판다파츠 1인 경우 버튼 예외 처리
  if (pics.source === "pandaparts" && Number(pics.item_price) === 1)
    return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.price) === 1)
    return renderInquiryButton();

  if (
    pics.source === "pandaparts" &&
    pics.item_price !== undefined &&
    pics.item_price !== 0
  )
    return renderBuyButton(`/parts/mallview/${pics.it_id}`);

  if (Number(pics.stock) === 0 || Number(pics.price) === 0)
    return renderInquiryButton();

  if (pics.source === "pandaparts")
    return renderBuyButton(`/parts/view/ON${pics.stock_no}`);

  if (data.manufacturer?.toLowerCase().includes("analog device"))
    return renderInquiryButton();

  return renderBuyButton(`/parts/view/PD${pics.stock_no}`);
};

export default Goto;
